// Build-id constants — populated by Vite `define` at build time.
//
// Operator-visible footer renders these so the operator can confirm
// the deployed bundle is the one they expect, not a stale mobile-
// webview cached copy.

declare const __GAO_BUILD_ID__: string;
declare const __GAO_COMMIT_SHA__: string;
declare const __GAO_BUILD_TIME__: string;

export const BUILD_ID: string =
  typeof __GAO_BUILD_ID__ === "string" ? __GAO_BUILD_ID__ : "unknown";
export const COMMIT_SHA: string =
  typeof __GAO_COMMIT_SHA__ === "string" ? __GAO_COMMIT_SHA__ : "unknown";
export const BUILD_TIME: string =
  typeof __GAO_BUILD_TIME__ === "string" ? __GAO_BUILD_TIME__ : "unknown";
